import React, { useEffect, useRef, useState } from "react"
import {
  Button,
  Card,
  Col,
  PopoverBody,
  Row,
  UncontrolledPopover,
} from "reactstrap"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import moment from "moment"
import { capitalize, isEmpty } from "lodash"
import { UFDate } from "../../../components/Common/Fields/Input"
import { useForm } from "react-hook-form"
import resetIcon from "../../../assets/icons/reset.svg"
import NumberFormat from "../../../utils/numberFormat"
import { useLocation, useNavigate } from "react-router-dom"
import {
  cacheClearProjectCostingReport,
  downloadProjectCost,
  fetchProjectCostingReport,
} from "../../../services/finance/finance"
import { useSelector, useDispatch } from "react-redux"
import { setFilter, removeFilter } from "../../../store/actions"
import { createSelector } from "reselect"
import ProjectBillingFilter from "./filter"
import LoadingButton from "../../../components/Common/LoadingButton"

const ProjectCostingReport = ({ fromDashboard, projectId }) => {
  document.title = "Project Costing | Everise"
  const dispatch = useDispatch()
  const [search, setSearch] = useState("")
  const [fetchedData, setFetchedData] = useState()
  const [page, setPage] = useState(1)
  const [ccNo, setCCNo] = useState("")
  const [type, setType] = useState("")
  const [productNo, setProductNo] = useState("")
  const [financial, setFinancial] = useState(true)
  const [startDate, setStartDate] = useState("")
  const [endDate, setEndDate] = useState("")
  const [company, setCompany] = useState(false)
  const [datefrom, setDatefrom] = useState("")
  const [dateto, setDateto] = useState("")
  const [dataPerPage, setDataPerPage] = useState(5)
  const desimalrange = localStorage.getItem("desimalrange")
  const [isLoadingNextPage, setIsLoadingNextPage] = useState(false)
  const [productData, setProductData] = useState()

  const [isLoading, setIsLoading] = useState(false)

  const [isDownloading, setIsDownloading] = useState(false)

  const [clearCache, setClearCache] = useState(0)

  const [tableTotalWidth, setTableTotalWidth] = useState(0)

  const selectFilterState = state => state.filterReducer
  const filterProperties = createSelector(selectFilterState, filter => ({
    filters: filter.filters,
    filterLoading: filter.loading,
    filterError: filter.error,
  }))

  const { filters, filterLoading, filterError } = useSelector(filterProperties)
  console.log("filtersdata", filters, filterLoading, filterError)

  useEffect(() => {
    if (
      filters?.dateFrom ||
      filters?.dateTo ||
      filters?.productData ||
      filters?.search
    ) {
      setStartDate(filters?.dateFrom || "")
      // setEndDate(filters?.dateTo || "")
      setProductData(filters?.productData || "")
      setSearch(filters?.search || "")
      const fetchData = async () => {
        setIsLoading(true)
        const response = await fetchProjectCostingReport({
          params: `${`cache=${clearCache}`}${`&type=project`}${
            productNo ? `&cost_center_id=${productNo}` : ""
          }${page ? `&page=${page}` : ""}${
            dataPerPage ? `&perPage=${dataPerPage}` : `&perPage=5`
          }${startDate ? `&start_date=${startDate}` : ""}${
            endDate ? `&end_date=${endDate}` : ""
          }`,
        })
        setEndDate(response?.data?.projects[0]?.current_date || "")

        // setFetchedData(response)
        const newData = response?.data || []

        setFetchedData(prev =>
          page > 1 && prev
            ? {
                ...response,
                data: [...(prev.data || []), ...newData],
              }
            : response
        )
        setIsLoading(false)
        setIsLoadingNextPage(response == undefined ? true : false)
        isLoadingRef.current = false
        // ${`&financial=${financial}`}
      }

      fetchData()
    }
  }, [
    filters?.dateFrom,
    filters?.dateTo,
    filters?.productData,
    filters?.search,
    startDate,
    endDate,
    clearCache,
  ])

  const { control, watch, reset } = useForm({
    defaultValues: {
      req_date: null,
    },
  })

  const locations = useLocation()
  const crumb = locations?.state?.menuLabel || ""

  const location = useLocation()
  const navigate = useNavigate()
  const { productId, productName } = location.state || {}

  const handlePaginate = page => {
    setPage(page)
  }

  const handleCCChange = id => {
    setCCNo(id)
    setPage(1)
  }

  const handleTypeChange = id => {
    setType(id)
    setPage(1)
  }

  const handleSearchChange = data => {
    setSearch(data)
    setPage(1)
  }
  const handleProductChange = data => {
    setProductNo(
      data?.value && typeof data?.value === "object"
        ? data.id
        : data?.value
        ? data?.value
        : ""
    )
    setProductData(data)
    setPage(1)
    if (!data) {
      // Clear location.state
      navigate(location.pathname, { replace: true, state: {} })
    }
    if (data == undefined) {
      dispatch(removeFilter())
    }
  }

  const handleFinacialChange = id => {
    setFinancial(id)
    setPage(1)
  }
  const handleCacheClear = async () => {
    // setClearCache(1)
    const responce = await cacheClearProjectCostingReport()
    //   {
    //   params: `${page ? `page=${page}` : ""}${
    //     productNo ? `&cost_center_id=${productNo}` : ""
    //   }${dataPerPage ? `&perPage=${dataPerPage}` : `&perPage=5`}${
    //     startDate ? `&start_date=${startDate}` : ""
    //   }${
    //     endDate ? `&end_date=${endDate}` : ""
    //   }${`&type=project`}${`&cache=${clearCache}`}`,
    // }
    setClearCache(1)
    console.log(`responce`, responce)

    setPage(1)
  }

  useEffect(() => {
    if (
      filters?.dateFrom ||
      filters?.dateTo ||
      filters?.productData ||
      filters?.search
    )
      return
    const fetchData = async () => {
      setIsLoading(true)
      const response = await fetchProjectCostingReport({
        params: `${productNo ? `&cost_center_id=${productNo}` : ""}${
          page ? `&page=${page}` : ""
        }${dataPerPage ? `&perPage=${dataPerPage}` : `&perPage=5`}${
          startDate ? `&start_date=${startDate}` : ""
        }${
          endDate ? `&end_date=${endDate}` : ""
        }${`&type=project`}${`&cache=${clearCache}`}`,
      })
      setEndDate(response?.data?.projects[0]?.current_date || "")
      // setFetchedData(response)
      const newData = response?.data || []
      setFetchedData(prev =>
        page > 1 && prev
          ? {
              ...response,

              data: [...(prev.data || []), ...newData],
            }
          : response
      )
      setIsLoading(false)
      setIsLoadingNextPage(response == undefined ? true : false)
      isLoadingRef.current = false
      // ${`&financial=${financial}`}
    }

    // if (
    //   datefrom &&
    //   dateto &&
    //   moment(datefrom).isSameOrBefore(moment(dateto)) &&
    //   productNo
    // ) {
    fetchData()
    // }
  }, [
    type,
    financial,
    ccNo,
    search,
    projectId,
    startDate,
    endDate,
    company,
    page,
    datefrom,
    dateto,
    productNo,
    dataPerPage,
    clearCache,
  ])

  const tableContainerRef = useRef(null)
  const isLoadingRef = useRef(false)
  const scrollTimeoutRef = useRef(null)

  const loadMoreRef = useRef(null)

  useEffect(() => {
    if (!loadMoreRef.current) return

    const observer = new IntersectionObserver(
      entries => {
        const target = entries[0]

        if (
          target.isIntersecting &&
          !isLoadingRef.current &&
          page < fetchedData?.meta?.last_page
        ) {
          isLoadingRef.current = true
          setIsLoadingNextPage(true)
          setPage(prev => prev + 1)
        }
      },
      { threshold: 1 }
    )

    observer.observe(loadMoreRef.current)

    return () => observer.disconnect()
  }, [fetchedData, page])

  useEffect(() => {
    const handleScroll = e => {
      const { scrollTop, scrollHeight, clientHeight } = e.target

      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current)
      }

      scrollTimeoutRef.current = setTimeout(() => {
        if (
          scrollTop + clientHeight >= scrollHeight - 50 &&
          !isLoadingRef.current &&
          page < fetchedData?.data?.meta?.last_page
        ) {
          isLoadingRef.current = true
          setIsLoadingNextPage(true)
          setPage(prev => prev + 1)
        }
      }, 200)
    }

    const container = tableContainerRef.current
    if (container) {
      container.addEventListener("scroll", handleScroll)
    }

    return () => {
      if (container) {
        container.removeEventListener("scroll", handleScroll)
      }
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current)
      }
    }
  }, [fetchedData, page])

  const getColumnTotal = key => {
    return NumberFormat(
      (fetchedData?.data || []).reduce(
        (sum, row) => sum + Number(row?.[key] || 0),
        0
      ),
      desimalrange,
      desimalrange
    )
  }

  const columns = [
    {
      label: "Project",
      renderCell: item =>
        fromDashboard ? (
          item?.cost_center_name
        ) : (
          <div
            // onClick={() => {
            //   navigate(`/finance-voucher/view/${item?.voucher_entry_id}`, {
            //     state: {
            //       bread: crumb,
            //     },
            //   })
            // }}
            className="fw-bold"
          >
            {" "}
            {item?.cost_center_name}{" "}
          </div>
        ),
      footerContent: () => "Total",
    },
    {
      label: <div className="text-end pe-5">Project Value</div>,
      renderCell: item => (
        <div className="text-end pe-5">
          {NumberFormat(
            Number(item?.projectAmount || 0),
            desimalrange,
            desimalrange
          )}
        </div>
      ),
      footerContent: () => (
        <div className="text-end pe-5">{getColumnTotal("projectAmount")}</div>
      ),
    },
    {
      label: <div className="text-end pe-5">Revenue</div>,
      renderCell: item => (
        <div className="text-end pe-5">
          {NumberFormat(
            Number(item?.revenue_amount || 0),
            desimalrange,
            desimalrange
          )}
        </div>
      ),
      footerContent: () => (
        <div className="text-end pe-5">{getColumnTotal("revenue_amount")}</div>
      ),
    },
    {
      label: <div className="text-end pe-5">Adv Bal</div>,
      renderCell: item => (
        <div className="text-end pe-5">
          {NumberFormat(
            Number(item?.adv_received_group || 0),
            desimalrange,
            desimalrange
          )}
        </div>
      ),
      footerContent: () => (
        <div className="text-end pe-5">
          {getColumnTotal("adv_received_group")}
        </div>
      ),
    },

    {
      label: <div className="text-end pe-5">Retention</div>,
      renderCell: item => (
        <div className="text-end pe-5">
          {NumberFormat(
            Number(item?.retention_group || 0),
            desimalrange,
            desimalrange
          )}
        </div>
      ),
      footerContent: () => (
        <div className="text-end pe-5">{getColumnTotal("retention_group")}</div>
      ),
    },
    {
      label: <div className="text-end pe-5">DLP</div>,
      renderCell: item => (
        <>
          <div className="text-end pe-5">
            {NumberFormat(
              Number(item?.dlp_group || 0),
              desimalrange,
              desimalrange
            )}
          </div>
        </>
      ),
      footerContent: () => (
        <div className="text-end pe-5">{getColumnTotal("dlp_group")}</div>
      ),
    },
    {
      label: <div className="text-end pe-5">Material</div>,
      renderCell: item => (
        <>
          <div className="text-end pe-5">
            {NumberFormat(
              Number(item?.material_purchase_group || 0),
              desimalrange,
              desimalrange
            )}
          </div>
        </>
      ),
      footerContent: () => (
        <div className="text-end pe-5">
          {getColumnTotal("material_purchase_group")}
        </div>
      ),
    },
    {
      label: <div className="text-end pe-5">Sub-Contract</div>,
      renderCell: item => (
        <>
          <div className="text-end pe-5">
            {NumberFormat(
              Number(item?.sub_contract_group || 0),
              desimalrange,
              desimalrange
            )}
          </div>
        </>
      ),
      footerContent: () => (
        <div className="text-end pe-5">
          {getColumnTotal("sub_contract_group")}
        </div>
      ),
    },
    {
      label: <div className="text-end pe-5">Supply Labour Cost</div>,
      renderCell: item => (
        <>
          <div className="text-end pe-5">
            {NumberFormat(
              Number(item?.manpower_group || 0),
              desimalrange,
              desimalrange
            )}
          </div>
        </>
      ),
      footerContent: () => (
        <div className="text-end pe-5">{getColumnTotal("manpower_group")}</div>
      ),
    },
    {
      label: <div className="text-end pe-5">Direct Labour Cost</div>,
      renderCell: item => (
        <>
          <div className="text-end pe-5">
            {NumberFormat(
              Number(item?.wages_group || 0),
              desimalrange,
              desimalrange
            )}
          </div>
        </>
      ),
      footerContent: () => (
        <div className="text-end pe-5">{getColumnTotal("wages_group")}</div>
      ),
    },
    {
      label: <div className="text-end pe-5">Total Direct Cost</div>,
      renderCell: item => (
        <>
          <div className="text-end pe-5">
            {NumberFormat(
              Number(item?.total_direct_cost || 0),
              desimalrange,
              desimalrange
            )}
          </div>
        </>
      ),
      footerContent: () => (
        <div className="text-end pe-5">
          {getColumnTotal("total_direct_cost")}
        </div>
      ),
    },
    {
      label: <div className="text-end pe-5">Contribution</div>,
      renderCell: item => (
        <>
          <div className="text-end pe-5">
            {NumberFormat(
              Number(item?.contribution_margin || 0),
              desimalrange,
              desimalrange
            )}
          </div>
        </>
      ),
      footerContent: () => (
        <div className="text-end pe-5">
          {getColumnTotal("contribution_margin")}
        </div>
      ),
    },
    {
      label: <div className="text-end pe-5">Staff Salary</div>,
      renderCell: item => (
        <>
          <div className="text-end pe-5">
            {NumberFormat(
              Number(item?.staff_salary_group || 0),
              desimalrange,
              desimalrange
            )}
          </div>
        </>
      ),
      footerContent: () => (
        <div className="text-end pe-5">
          {getColumnTotal("staff_salary_group")}
        </div>
      ),
    },
    {
      label: <div className="text-end pe-5">Admin & General</div>,
      renderCell: item => (
        <>
          <div className="text-end pe-5">
            {NumberFormat(
              Number(item?.admin_general_group || 0),
              desimalrange,
              desimalrange
            )}
          </div>
        </>
      ),
      footerContent: () => (
        <div className="text-end pe-5">
          {getColumnTotal("admin_general_group")}
        </div>
      ),
    },

    {
      label: <div className="text-end pe-5">Other In-Direct Cost</div>,
      renderCell: item => (
        <>
          <div className="text-end pe-5">
            {NumberFormat(
              Number(item?.other_indirect_expense_group || 0),
              desimalrange,
              desimalrange
            )}
          </div>
        </>
      ),
      footerContent: () => (
        <div className="text-end pe-5">
          {getColumnTotal("other_indirect_expense_group")}
        </div>
      ),
    },
    {
      label: <div className="text-end pe-5">Total In-Direct Cost</div>,
      renderCell: item => (
        <>
          <div className="text-end pe-5">
            {NumberFormat(
              Number(item?.total_indirect_expense || 0),
              desimalrange,
              desimalrange
            )}
          </div>
        </>
      ),
      footerContent: () => (
        <div className="text-end pe-5">
          {getColumnTotal("total_indirect_expense")}
        </div>
      ),
    },
    {
      label: <div className="">NP</div>,
      renderCell: item => (
        <>
          <div>{item?.mp ? "True" : "False"}</div>
        </>
      ),
    },
  ]

  const handleRequestdate = data => {
    let fromDate = ""
    let toDate = ""
    console.log(`fromDate 1`, fromDate, toDate)

    fromDate = !isEmpty(data) ? moment(data[0]).format("YYYY-MM-DD") : ""
    toDate = !isEmpty(data) ? moment(data[1]).format("YYYY-MM-DD") : ""
    console.log(`fromDate 2`, fromDate, toDate)
    setStartDate(fromDate)
    setEndDate(toDate)
  }

  const handleSizePerPageChange = size => {
    setDataPerPage(size)
  }

  const handleReset = () => {
    reset({ req_date: null })
    setStartDate("")
    setEndDate("")
  }

  const handleCompanyChange = id => {
    setCompany(id)
    setPage(1)
  }

  const handleDateChange = (fromdate, todate) => {
    setStartDate(fromdate)
    setEndDate(todate)
    setPage(1)
    setDataPerPage(25)
  }

  const totalAgainstPayment = (voucherEntries = []) => {
    return voucherEntries.reduce((sum, entry) => {
      const innerSum = (entry?.against_payment || []).reduce(
        (acc, ap) => acc + Number(ap?.amount || 0),
        0
      )
      return sum + innerSum
    }, 0)
  }

  const totalNetReceivable = (voucherEntries = []) => {
    return voucherEntries.reduce(
      (sum, entry) => sum + Number(entry?.net_receivable || 0),
      0
    )
  }

  const getProjectSum = (projects, field) => {
    return projects?.reduce(
      (sum, dt) => sum + Number(dt?.cost_center?.[field] || 0),
      0
    )
  }

  const getProjectSums = (projects, fieldPath) => {
    if (!projects?.length) return 0

    return projects.reduce((sum, p) => {
      const value = fieldPath.split(".").reduce((obj, key) => obj?.[key], p)

      return sum + Number(value || 0)
    }, 0)
  }

  const maxInvoiceCount = Math.max(
    0, // default minimum to avoid -Infinity
    ...(fetchedData?.data?.projects.map(
      p => p?.financial_summary?.sales?.invoices?.length || 0
    ) || [])
  )
  const maxSubContCount = Math.max(
    0, // default minimum to avoid -Infinity
    ...(fetchedData?.data?.projects.map(
      p =>
        p?.financial_summary?.costs?.direct?.subcontractors?.vendors?.length ||
        0
    ) || [])
  )
  const maxLabourHCount = Math.max(
    0, // default minimum to avoid -Infinity
    ...(fetchedData?.data?.projects.map(
      p =>
        p?.financial_summary?.costs?.direct?.labor?.hired?.employees?.length ||
        0
    ) || [])
  )
  const maxLabourICount = Math.max(
    0, // default minimum to avoid -Infinity
    ...(fetchedData?.data?.projects.map(
      p =>
        p?.financial_summary?.costs?.direct?.labor?.in_house?.employees
          ?.length || 0
    ) || [])
  )

  const maxOtherCount = Math.max(
    0, // default minimum to avoid -Infinity
    ...(fetchedData?.data?.projects.map(
      p => p?.financial_summary?.costs?.direct?.others?.items?.length || 0
    ) || [])
  )

  const allRows = []

  const allIndirectRows = []

  fetchedData?.data?.projects?.forEach(proj => {
    const groups = proj?.financial_summary?.costs?.direct?.other?.groups || []

    groups.forEach(grp => {
      const grpName = grp.group_name

      // Ledgers under main group
      grp.ledgers?.forEach(ld => {
        allRows.push({
          group: grpName,
          child: null,
          ledger: ld.ledger_name,
        })
      })

      // Child groups
      grp.children?.forEach(child => {
        const childName = child.group_name

        child.ledgers?.forEach(ld => {
          allRows.push({
            group: grpName,
            child: childName,
            ledger: ld.ledger_name,
          })
        })
      })
    })
  })

  fetchedData?.data?.projects?.forEach(proj => {
    const groups = proj?.financial_summary?.costs?.indirect?.groups || []

    groups.forEach(grp => {
      const grpName = grp.group_name

      // Ledgers under main group
      grp.ledgers?.forEach(ld => {
        allIndirectRows.push({
          group: grpName,
          child: null,
          ledger: ld.ledger_name,
        })
      })

      // Child groups
      grp.children?.forEach(child => {
        const childName = child.group_name

        child.ledgers?.forEach(ld => {
          allIndirectRows.push({
            group: grpName,
            child: childName,
            ledger: ld.ledger_name,
          })
        })
      })
    })
  })

  // Unique rows
  const uniqueRows = Array.from(
    new Map(allRows.map(r => [`${r.group}|${r.child}|${r.ledger}`, r])).values()
  )
  const uniqueIDRows = Array.from(
    new Map(
      allIndirectRows.map(r => [`${r.group}|${r.child}|${r.ledger}`, r])
    ).values()
  )

  const [expandedGroups, setExpandedGroups] = useState({})
  const [expandedIDGroups, setExpandedIDGroups] = useState({})

  const toggleGroupExpand = groupName => {
    setExpandedGroups(prev => ({
      ...prev,
      [groupName]: !prev[groupName],
    }))
  }
  const toggleGroupIDExpand = groupName => {
    setExpandedIDGroups(prev => ({
      ...prev,
      [groupName]: !prev[groupName],
    }))
  }

  const handleDownload = async downloadConfig => {
    setIsDownloading(true)
    try {
      await downloadProjectCost(downloadConfig)
    } catch (error) {
      console.error("Download failed:", error)
    } finally {
      setIsDownloading(false)
    }
  }

  console.log(`maxOtherCount`, maxOtherCount)

  return (
    <React.Fragment>
      <div className={`page-content ${fromDashboard ? "pt-0" : ""}`}>
        <div className="container-fluid">
          <div className="d-flex justify-content-between">
            {!fromDashboard ? (
              <Breadcrumbs
                title="Finance"
                breadcrumbObject={[
                  { title: "Finance", link: "/finance" },
                  { title: crumb || "Reports", link: "#" },
                  {
                    title: "Project Costing",
                    link: "#",
                  },
                ]}
              />
            ) : (
              <></>
            )}
            <>
              <div className="me-2">
                <span id={`PopoverLegacy-1`} className="px-2 btn btn-primary">
                  Download
                </span>
              </div>
              <UncontrolledPopover
                placement="bottom"
                target={`PopoverLegacy-1`}
                trigger="legacy"
              >
                <PopoverBody>
                  {isDownloading ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      
                    </>
                  ) : (
                    <>
                      <div
                        className="table-popup-content"
                        onClick={() => {
                          if (!isDownloading) {
                            handleDownload({
                              params: `export_format=pdf&account_group_id=24&cache=0&cc_type=project${`&type=project`}${
                                productNo ? `&cost_center_id=${productNo}` : ""
                              }${startDate ? `&start_date=${startDate}` : ""}${
                                endDate ? `&end_date=${endDate}` : ""
                              }`,
                              type: "pdf",
                              fileName: "project_cost.pdf",
                            })
                          }
                        }}
                        style={{
                          cursor: isDownloading ? "not-allowed" : "pointer",
                          opacity: isDownloading ? 0.6 : 1,
                          pointerEvents: isDownloading ? "none" : "auto",
                        }}
                      >
                        {isDownloading ? (
                          <>
                            <span
                              className="spinner-border spinner-border-sm me-2"
                              role="status"
                              aria-hidden="true"
                            ></span>
                          </>
                        ) : (
                          "PDF"
                        )}
                      </div>
                      <div
                        className="table-popup-content"
                        onClick={() => {
                          if (!isDownloading) {
                            handleDownload({
                              params: `export_format=excel&cache=0&account_group_id=24&cc_type=project${`&type=project`}${
                                productNo ? `&cost_center_id=${productNo}` : ""
                              }${startDate ? `&start_date=${startDate}` : ""}${
                                endDate ? `&end_date=${endDate}` : ""
                              }`,
                              type: "excel",
                              fileName: "project_cost.xlsx",
                            })
                          }
                        }}
                        style={{
                          cursor: isDownloading ? "not-allowed" : "pointer",
                          opacity: isDownloading ? 0.6 : 1,
                          pointerEvents: isDownloading ? "none" : "auto",
                        }}
                      >
                        {isDownloading ? (
                          <>
                            <span
                              className="spinner-border spinner-border-sm me-2"
                              role="status"
                              aria-hidden="true"
                            ></span>
                            Downloading Excel...
                          </>
                        ) : (
                          "Excel"
                        )}
                      </div>
                    </>
                  )}
                </PopoverBody>
              </UncontrolledPopover>
              {/* <UncontrolledPopover
                placement="bottom"
                target={`PopoverLegacy-1`}
                trigger="legacy"
              >
                <PopoverBody>
                  <div
                    className="table-popup-content"
                    onClick={() =>
                      downloadProjectCost({
                        params: `export_format=pdf&account_group_id=24&cache=0&cc_type=project${`&type=project`}${
                          productNo ? `&cost_center_id=${productNo}` : ""
                        }${startDate ? `&start_date=${startDate}` : ""}${
                          endDate ? `&end_date=${endDate}` : ""
                        }`,
                        type: "pdf",
                        fileName: "project_cost.pdf",
                      })
                    }
                  >
                    PDF
                  </div>
                  <div
                    className="table-popup-content"
                    onClick={() =>
                      downloadProjectCost({
                        params: `export_format=excel&cache=0&account_group_id=24&cc_type=project${`&type=project`}${
                          productNo ? `&cost_center_id=${productNo}` : ""
                        }${startDate ? `&start_date=${startDate}` : ""}${
                          endDate ? `&end_date=${endDate}` : ""
                        }`,
                        type: "excel",
                        fileName: "project_cost.xlsx",
                      })
                    }
                  >
                    Excel
                  </div>
                </PopoverBody>
              </UncontrolledPopover> */}
            </>
          </div>

          <Card
            className={`me-2 px-2 pb-2 ${fromDashboard ? "dash-table-bg" : ""}`}
          >
            {fromDashboard ? (
              <div className="px-2 py-3">Transaction History</div>
            ) : (
              <ProjectBillingFilter
                // handleCCChange={handleCCChange}
                handleTypeChange={handleTypeChange}
                handleSearchChange={handleSearchChange}
                handleDateChange={handleDateChange}
                handleProductChange={handleProductChange}
                handleFinacialChange={handleFinacialChange}
                handleCompanyChange={handleCompanyChange}
                handleCacheClear={handleCacheClear}
                resetData={{
                  fromData: datefrom,
                  toData: fetchedData?.data?.projects[0]?.current_date || "",
                  productData: productData,
                  search: search,
                }}
                {...(location?.state && {
                  productId,
                  productName,
                })}
              />
            )}
            <hr className="table-divide" />
            <div>
              {fromDashboard && (
                <Row className="pt-2">
                  <Col sm={6}>
                    <UFDate
                      control={control}
                      placeholder="Date"
                      name={"req_date"}
                      mode="range"
                      className="ufinput-dashboard"
                      onDateChange={e => handleRequestdate(e)}
                    />
                  </Col>
                  <Col sm={3}></Col>
                  <Col sm={3}>
                    <div
                      className="pointer me-2 text-white btn btn-primary float-end"
                      onClick={() => handleReset()}
                    >
                      <img
                        src={resetIcon}
                        height={15}
                        width={15}
                        className="me-2 svg-clr-reset"
                      />{" "}
                      Reset
                    </div>
                  </Col>
                </Row>
              )}
              <Row
                className={`ever-rise-table ${
                  fromDashboard ? "dashboardTable" : ""
                } `}
              >
                <Col xs={12}>
                  {fetchedData?.data?.projects?.length ? (
                    <div
                      ref={tableContainerRef}
                      style={{ maxHeight: "490px", overflowY: "auto" }}
                      className="table-scroll-x"
                    >
                      <table
                        className="estimation-table costing-tbl mb-4"
                        style={{
                          width: productNo
                            ? "100%"
                            : fetchedData?.data?.projects?.length < 2
                            ? "100%"
                            : `${
                                Number(fetchedData?.data?.projects?.length) *
                                500
                              }px`,
                        }}
                      >
                        <thead>
                          <tr>
                            <th className="wdt-40px">Project Number</th>
                            {fetchedData?.data?.projects?.map((dt, i) => {
                              const name = dt?.cost_center?.name || ""
                              const code = name.split(" ")[0]

                              return (
                                <th key={i} className="wdt-40px">
                                  {code}
                                </th>
                              )
                            })}
                            <th className="wdt-40px text-end me-2">
                              Overall Total
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <th className="wdt-40px">Customer</th>
                            {fetchedData?.data?.projects?.map((dt, i) => (
                              <th
                                key={i}
                                className="wdt-40px"
                                title={dt?.cost_center?.name}
                              >
                                {dt?.cost_center?.customer_name
                                  ? dt?.cost_center?.customer_name
                                  : "-"}
                              </th>
                            ))}
                            <th className="wdt-40px"></th>
                          </tr>
                          <tr>
                            <td className="wdt-40px">Project</td>
                            {fetchedData?.data?.projects?.map((dt, i) => {
                              const name = dt?.cost_center?.name || ""

                              // Remove only the first word (the code)
                              const cleanName = name.substring(
                                name.indexOf(" ")
                              )

                              return (
                                <td
                                  key={i}
                                  className="wdt-40px me-2"
                                  title={cleanName}
                                >
                                  {cleanName}
                                </td>
                              )
                            })}

                            <td className="wdt-40px"></td>
                          </tr>
                          <tr>
                            <td className="wdt-40px">Customer Code</td>
                            {fetchedData?.data?.projects?.map((dt, i) => (
                              <td
                                key={i}
                                className="wdt-40px me-2"
                                title={dt?.cost_center?.customer_code}
                              >
                                {dt?.cost_center?.customer_code
                                  ? dt?.cost_center?.customer_code
                                  : "-"}
                              </td>
                            ))}

                            <td className="wdt-40px"></td>
                          </tr>
                          <tr>
                            <td className="wdt-40px">Contract Value</td>
                            {fetchedData?.data?.projects?.map((dt, i) => (
                              <td
                                key={i}
                                className="wdt-40px me-2 text-end"
                                title={dt?.cost_center?.contract_value || 0}
                              >
                                <div className="me-2">
                                  {NumberFormat(
                                    Number(
                                      dt?.cost_center?.contract_value || 0
                                    ),
                                    desimalrange,
                                    desimalrange
                                  )}
                                </div>
                              </td>
                            ))}
                            <td className="wdt-40px text-end">
                              <div className="me-2">
                                {NumberFormat(
                                  getProjectSum(
                                    fetchedData?.data?.projects,
                                    "contract_value"
                                  ),
                                  desimalrange,
                                  desimalrange
                                )}
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td className="wdt-40px">Variation</td>
                            {fetchedData?.data?.projects?.map((dt, i) => (
                              <td
                                key={i}
                                className="wdt-40px me-2 text-end"
                                title={0.0}
                              >
                                <div className="me-2">
                                  {NumberFormat(
                                    Number(0),
                                    desimalrange,
                                    desimalrange
                                  )}
                                </div>
                              </td>
                            ))}
                            <td className="wdt-40px text-end">
                              <div className="me-2">
                                {NumberFormat(0, desimalrange, desimalrange)}
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td className="wdt-40px">Final value</td>
                            {fetchedData?.data?.projects?.map((dt, i) => (
                              <td
                                key={i}
                                className="wdt-40px me-2 text-end"
                                title={dt?.cost_center?.final_value || 0}
                              >
                                <div className="me-2">
                                  {NumberFormat(
                                    Number(dt?.cost_center?.final_value || 0),
                                    desimalrange,
                                    desimalrange
                                  )}
                                </div>
                              </td>
                            ))}
                            <td className="wdt-40px text-end">
                              <div className="me-2">
                                {NumberFormat(
                                  getProjectSum(
                                    fetchedData?.data?.projects,
                                    "final_value"
                                  ),
                                  desimalrange,
                                  desimalrange
                                )}
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td className="wdt-40px">VAT @5</td>
                            {fetchedData?.data?.projects?.map((dt, i) => (
                              <td
                                key={i}
                                className="wdt-40px me-2 text-end"
                                title={dt?.cost_center?.vat_percentage || 0}
                              >
                                <div className="me-2">
                                  {NumberFormat(
                                    Number(
                                      dt?.cost_center?.vat_percentage || 0
                                    ),
                                    desimalrange,
                                    desimalrange
                                  )}
                                </div>
                              </td>
                            ))}
                            <td className="wdt-40px text-end">
                              <div className="me-2">
                                {NumberFormat(
                                  getProjectSum(
                                    fetchedData?.data?.projects,
                                    "vat_percentage"
                                  ),
                                  desimalrange,
                                  desimalrange
                                )}
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <td className="wdt-40px">Total Value</td>
                            {fetchedData?.data?.projects?.map((dt, i) => (
                              <td
                                key={i}
                                className="wdt-40px me-2 text-end"
                                title={dt?.cost_center?.total_value || 0}
                              >
                                <div className="me-2">
                                  {NumberFormat(
                                    Number(dt?.cost_center?.total_value || 0),
                                    desimalrange,
                                    desimalrange
                                  )}
                                </div>
                              </td>
                            ))}
                            <td className="wdt-40px text-end">
                              <div className="me-2">
                                {NumberFormat(
                                  getProjectSum(
                                    fetchedData?.data?.projects,
                                    "total_value"
                                  ),
                                  desimalrange,
                                  desimalrange
                                )}
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <th></th>
                            {fetchedData?.data?.projects?.map((dt, i) => (
                              <th key={i} className="wdt-40px me-2"></th>
                            ))}
                            <th></th>
                          </tr>
                          <tr>
                            <th>Description</th>
                          </tr>
                          <tr>
                            <th>Sales - Invoice</th>
                          </tr>
                          {fetchedData?.data?.projects?.length > 0 &&
                            [...Array(maxInvoiceCount)].map((_, rowIndex) => (
                              <tr key={rowIndex}>
                                <td className="wdt-40px">
                                  Invoice {rowIndex + 1}
                                </td>

                                {fetchedData.data.projects.map(
                                  (proj, colIndex) => {
                                    const invoice =
                                      proj?.financial_summary?.sales
                                        ?.invoices?.[rowIndex]?.number || 0
                                    return (
                                      <td
                                        key={colIndex}
                                        className="wdt-40px me-2 text-end"
                                      >
                                        <div className="me-2">
                                          {NumberFormat(
                                            Number(invoice),
                                            desimalrange,
                                            desimalrange
                                          )}
                                        </div>
                                      </td>
                                    )
                                  }
                                )}

                                {/* Total for this invoice row */}
                                <td className="wdt-40px text-end">
                                  <div className="me-2">
                                    {NumberFormat(
                                      fetchedData.data.projects.reduce(
                                        (sum, proj) => {
                                          const inv =
                                            proj?.financial_summary?.sales
                                              ?.invoices?.[rowIndex]?.number ||
                                            0
                                          return sum + Number(inv)
                                        },
                                        0
                                      ),
                                      desimalrange,
                                      desimalrange
                                    )}
                                  </div>
                                </td>
                              </tr>
                            ))}
                          <tr>
                            <th></th>
                            {fetchedData?.data?.projects?.map((dt, i) => (
                              <th key={i} className="wdt-40px me-2"></th>
                            ))}
                            <th></th>
                          </tr>
                          <tr>
                            <th className="wdt-40px">Total Sales Value</th>
                            {fetchedData?.data?.projects?.map((dt, i) => (
                              <th
                                key={i}
                                className="wdt-40px me-2 text-end"
                                title={
                                  dt?.financial_summary?.sales?.total_revenue ||
                                  0
                                }
                              >
                                <div className="me-2">
                                  {NumberFormat(
                                    Number(
                                      dt?.financial_summary?.sales
                                        ?.total_revenue || 0
                                    ),
                                    desimalrange,
                                    desimalrange
                                  )}
                                </div>
                              </th>
                            ))}
                            <th className="wdt-40px text-end">
                              <div className="me-2">
                                {NumberFormat(
                                  getProjectSums(
                                    fetchedData?.data?.projects,
                                    "financial_summary.sales.total_revenue"
                                  ),
                                  desimalrange,
                                  desimalrange
                                )}
                              </div>
                            </th>
                          </tr>
                          <tr>
                            <th></th>
                            {fetchedData?.data?.projects?.map((dt, i) => (
                              <th key={i} className="wdt-40px me-2"></th>
                            ))}
                            <th></th>
                          </tr>
                          <tr>
                            <th>Direct Material Purchases</th>
                          </tr>
                          {fetchedData?.data?.projects?.[0]?.financial_summary?.costs?.direct?.materials?.monthly_purchase?.map(
                            (month, monthIndex) => (
                              <tr key={monthIndex}>
                                <td className="wdt-40px" title={month?.label}>
                                  {month.label}
                                </td>

                                {/* Each project's monthly amount */}
                                {fetchedData.data.projects.map(
                                  (proj, projIndex) => {
                                    const amount =
                                      proj?.financial_summary?.costs?.direct
                                        ?.materials?.monthly_purchase?.[
                                        monthIndex
                                      ]?.amount || 0

                                    return (
                                      <td
                                        className="wdt-40px text-end"
                                        key={projIndex}
                                      >
                                        <div className="me-2">
                                          {NumberFormat(
                                            Number(amount),
                                            desimalrange,
                                            desimalrange
                                          )}
                                        </div>
                                      </td>
                                    )
                                  }
                                )}

                                {/* 🔥 Total for this month across all projects */}
                                <td className="wdt-40px text-end">
                                  <div className="me-2">
                                    {NumberFormat(
                                      fetchedData.data.projects.reduce(
                                        (sum, proj) => {
                                          const amt =
                                            proj?.financial_summary?.costs
                                              ?.direct?.materials
                                              ?.monthly_purchase?.[monthIndex]
                                              ?.amount || 0
                                          return sum + amt
                                        },
                                        0
                                      ),
                                      desimalrange,
                                      desimalrange
                                    )}
                                  </div>
                                </td>
                              </tr>
                            )
                          )}

                          <tr>
                            <th></th>
                            {fetchedData?.data?.projects?.map((dt, i) => (
                              <th key={i} className="wdt-40px me-2"></th>
                            ))}
                            <th></th>
                          </tr>
                          <tr>
                            <th
                              className="wdt-40px"
                              title="Total Material Cost"
                            >
                              Total Material Cost
                            </th>

                            {/* First column = label */}
                            {fetchedData.data.projects.map(
                              (proj, projIndex) => {
                                const amount =
                                  proj?.financial_summary?.costs?.direct
                                    ?.materials?.total || 0
                                return (
                                  <th
                                    className="wdt-40px text-end"
                                    key={projIndex}
                                  >
                                    <div className="me-2">
                                      {NumberFormat(
                                        Number(amount),
                                        desimalrange,
                                        desimalrange
                                      )}
                                    </div>
                                  </th>
                                )
                              }
                            )}

                            {/* Total for this month across all projects */}
                            <th className="wdt-40px text-end">
                              <div className="me-2">
                                {NumberFormat(
                                  fetchedData?.data?.projects?.reduce(
                                    (sum, proj) => {
                                      const projectTotal =
                                        proj?.financial_summary?.costs?.direct
                                          ?.materials?.total || 0

                                      return sum + projectTotal
                                    },
                                    0
                                  ),
                                  desimalrange,
                                  desimalrange
                                )}
                              </div>
                            </th>
                          </tr>
                          {maxSubContCount >= 1 && (
                            <>
                              <tr>
                                <th className="wdt-40px">
                                  Direct Cost - Sub-Contracts
                                </th>
                              </tr>
                              {fetchedData?.data?.projects?.length > 0 &&
                                [...Array(maxSubContCount)].map(
                                  (_, rowIndex) => (
                                    <tr key={rowIndex}>
                                      <td className="wdt-40px">
                                        SC Bill {rowIndex + 1}
                                      </td>

                                      {fetchedData.data.projects.map(
                                        (proj, colIndex) => {
                                          const invoice =
                                            proj?.financial_summary?.costs
                                              ?.direct?.subcontractors
                                              ?.vendors?.[rowIndex]
                                              ?.total_amount || 0
                                          const vendorName =
                                            proj?.financial_summary?.costs
                                              ?.direct?.subcontractors
                                              ?.vendors?.[rowIndex]
                                              ?.vendor_name || "-"
                                          return (
                                            <td
                                              key={colIndex}
                                              className="wdt-40px me-2"
                                            >
                                              <div title={vendorName}>
                                                {vendorName}
                                              </div>
                                              <div className=" text-end me-2">
                                                {NumberFormat(
                                                  Number(invoice),
                                                  desimalrange,
                                                  desimalrange
                                                )}
                                              </div>
                                            </td>
                                          )
                                        }
                                      )}

                                      {/* Total for this invoice row */}
                                      <td className="wdt-40px text-end">
                                        <div className="me-2">
                                          {NumberFormat(
                                            fetchedData.data.projects.reduce(
                                              (sum, proj) => {
                                                const inv =
                                                  proj?.financial_summary?.costs
                                                    ?.direct?.subcontractors
                                                    ?.vendors?.[rowIndex]
                                                    ?.number || 0
                                                return sum + Number(inv)
                                              },
                                              0
                                            ),
                                            desimalrange,
                                            desimalrange
                                          )}
                                        </div>
                                      </td>
                                    </tr>
                                  )
                                )}
                              <tr>
                                <th></th>
                                {fetchedData?.data?.projects?.map((dt, i) => (
                                  <th key={i} className="wdt-40px me-2"></th>
                                ))}
                                <th></th>
                              </tr>
                              <tr>
                                <th
                                  className="wdt-40px"
                                  title="Sub total - Sub-contractors "
                                >
                                  Sub total - Sub-contractors
                                </th>
                                {fetchedData?.data?.projects?.map((dt, i) => (
                                  <th
                                    key={i}
                                    className="wdt-40px me-2 text-end"
                                    title={
                                      dt?.financial_summary?.costs?.direct
                                        ?.subcontractors?.total || 0
                                    }
                                  >
                                    <div className="me-2">
                                      {NumberFormat(
                                        Number(
                                          dt?.financial_summary?.costs?.direct
                                            ?.subcontractors?.total || 0
                                        ),
                                        desimalrange,
                                        desimalrange
                                      )}
                                    </div>
                                  </th>
                                ))}
                                <th className="wdt-40px text-end">
                                  <div className="me-2">
                                    {NumberFormat(
                                      getProjectSum(
                                        fetchedData?.data?.projects,
                                        "financial_summary.costs.direct.subcontractors.total"
                                      ),
                                      desimalrange,
                                      desimalrange
                                    )}
                                  </div>
                                </th>
                              </tr>
                              <tr>
                                <th></th>
                                {fetchedData?.data?.projects?.map((dt, i) => (
                                  <th key={i} className="wdt-40px me-2"></th>
                                ))}
                                <th></th>
                              </tr>
                            </>
                          )}
                          {maxLabourHCount >= 1 && (
                            <>
                              <tr>
                                <th></th>
                              </tr>
                              {fetchedData?.data?.projects?.length > 0 &&
                                [...Array(maxLabourHCount)].map(
                                  (_, rowIndex) => (
                                    <tr key={rowIndex}>
                                      <td className="wdt-40px">
                                        Direct Labour - Hired
                                      </td>

                                      {fetchedData.data.projects.map(
                                        (proj, colIndex) => {
                                          const invoice =
                                            proj?.financial_summary?.costs
                                              ?.direct?.labor?.hired
                                              ?.employees?.[rowIndex]?.amount ||
                                            0
                                          const hiredName =
                                            proj?.financial_summary?.costs
                                              ?.direct?.labor?.hired
                                              ?.employees?.[rowIndex]?.name ||
                                            ""
                                          return (
                                            <td
                                              key={colIndex}
                                              className="wdt-40px me-2"
                                            >
                                              <div title={hiredName}>
                                                {hiredName}
                                              </div>
                                              <div className=" text-end me-2">
                                                {NumberFormat(
                                                  Number(invoice),
                                                  desimalrange,
                                                  desimalrange
                                                )}
                                              </div>
                                            </td>
                                          )
                                        }
                                      )}

                                      {/* Total for this invoice row */}
                                      <td className="wdt-40px text-end">
                                        <div className="me-2">
                                          {NumberFormat(
                                            fetchedData.data.projects.reduce(
                                              (sum, proj) => {
                                                const inv =
                                                  proj?.financial_summary?.costs
                                                    ?.direct?.labor?.hired
                                                    ?.employees?.[rowIndex]
                                                    ?.amount || 0
                                                return sum + Number(inv)
                                              },
                                              0
                                            ),
                                            desimalrange,
                                            desimalrange
                                          )}
                                        </div>
                                      </td>
                                    </tr>
                                  )
                                )}
                              <tr>
                                <th></th>
                                {fetchedData?.data?.projects?.map((dt, i) => (
                                  <th key={i} className="wdt-40px me-2"></th>
                                ))}
                                <th></th>
                              </tr>
                              <tr>
                                <th></th>
                                {fetchedData?.data?.projects?.map((dt, i) => (
                                  <th key={i} className="wdt-40px me-2"></th>
                                ))}
                                <th></th>
                              </tr>
                              <tr>
                                <th></th>
                              </tr>
                            </>
                          )}
                          {maxLabourICount >= 1 && (
                            <>
                              {fetchedData?.data?.projects?.length > 0 &&
                                [...Array(maxLabourICount)].map(
                                  (_, rowIndex) => (
                                    <tr key={rowIndex}>
                                      <td className="wdt-40px">
                                        Direct Labour - In-House
                                      </td>

                                      {fetchedData.data.projects.map(
                                        (proj, colIndex) => {
                                          const invoice =
                                            proj?.financial_summary?.costs
                                              ?.direct?.labor?.in_house
                                              ?.employees?.[rowIndex]?.amount ||
                                            0
                                          const empName =
                                            proj?.financial_summary?.costs
                                              ?.direct?.labor?.in_house
                                              ?.employees?.[rowIndex]?.name ||
                                            "-"
                                          return (
                                            <td
                                              key={colIndex}
                                              className="wdt-40px me-2"
                                            >
                                              <div>{empName}</div>
                                              <div className=" text-end me-2">
                                                {NumberFormat(
                                                  Number(invoice),
                                                  desimalrange,
                                                  desimalrange
                                                )}
                                              </div>
                                            </td>
                                          )
                                        }
                                      )}

                                      {/* Total for this invoice row */}
                                      <td className="wdt-40px text-end">
                                        <div className="me-2">
                                          {NumberFormat(
                                            fetchedData.data.projects.reduce(
                                              (sum, proj) => {
                                                const inv =
                                                  proj?.financial_summary?.costs
                                                    ?.direct?.labor?.hired
                                                    ?.employees?.[rowIndex]
                                                    ?.amount || 0
                                                return sum + Number(inv)
                                              },
                                              0
                                            ),
                                            desimalrange,
                                            desimalrange
                                          )}
                                        </div>
                                      </td>
                                    </tr>
                                  )
                                )}
                              <tr>
                                <th></th>
                                {fetchedData?.data?.projects?.map((dt, i) => (
                                  <th key={i} className="wdt-40px me-2"></th>
                                ))}
                                <th></th>
                              </tr>

                              <tr>
                                <th className="wdt-40px"></th>
                                {fetchedData?.data?.projects?.map((dt, i) => (
                                  <th
                                    key={i}
                                    className="wdt-40px me-2 text-end"
                                    title={
                                      dt?.financial_summary?.costs?.direct
                                        ?.labor?.total || 0
                                    }
                                  >
                                    <div className="me-2">
                                      {NumberFormat(
                                        Number(
                                          dt?.financial_summary?.costs?.direct
                                            ?.labor?.total || 0
                                        ),
                                        desimalrange,
                                        desimalrange
                                      )}
                                    </div>
                                  </th>
                                ))}
                                <th className="wdt-40px text-end">
                                  <div className="me-2">
                                    {NumberFormat(
                                      getProjectSum(
                                        fetchedData?.data?.projects,
                                        "financial_summary.costs.direct.labor.total"
                                      ),
                                      desimalrange,
                                      desimalrange
                                    )}
                                  </div>
                                </th>
                              </tr>
                            </>
                          )}

                          <tr>
                            <th className="wdt-40px">Other Direct Cost </th>
                          </tr>
                          {(() => {
                            const projectCount =
                              fetchedData?.data?.projects?.length || 0
                            const totalCols = projectCount + 2
                            const groups = [
                              ...new Set(uniqueRows.map(r => r.group)),
                            ]

                            return groups.map((groupName, gi) => {
                              const rowsForGroup = uniqueRows.filter(
                                r => r.group === groupName
                              )
                              const isExpanded =
                                expandedGroups[groupName] || false

                              return (
                                <React.Fragment key={`group-${gi}`}>
                                  {/* Toggle Row */}
                                  <tr
                                    className="cursor-pointer"
                                    onClick={() => toggleGroupExpand(groupName)}
                                    style={{ backgroundColor: "#f8f9fa" }}
                                  >
                                    <td colSpan={totalCols} className="p-2">
                                      <div className="d-flex align-items-center">
                                        <span
                                          className="me-2"
                                          style={{
                                            transform: isExpanded
                                              ? "rotate(90deg)"
                                              : "rotate(0deg)",
                                            transition: "transform 0.3s ease",
                                            display: "inline-block",
                                          }}
                                        >
                                          ▶
                                        </span>
                                        <strong>{groupName}</strong>
                                      </div>
                                    </td>
                                  </tr>

                                  {/* Expanded Details Row */}
                                  {isExpanded && (
                                    <>
                                      {/* <td
                                        colSpan={totalCols}
                                        className="p-0 border-0"
                                      >
                                        <table className="table table-bordered table-sm mb-0">
                                          <thead>
                                            <tr
                                              style={{
                                                backgroundColor: "#f0f0f0",
                                              }}
                                            >
                                              <th>Ledger</th>
                                              {fetchedData?.data?.projects?.map(
                                                (p, i) => (
                                                  <th
                                                    key={i}
                                                    className="text-end"
                                                  >
                                                    {p.cost_center.name}
                                                  </th>
                                                )
                                              )}
                                              <th className="text-end">
                                                Total
                                              </th>
                                            </tr>
                                          </thead>

                                          <tbody> */}
                                      {rowsForGroup.map((row, ri) => (
                                        <tr key={ri}>
                                          <td className="wdt-40px">
                                            {row.child && (
                                              <div className="text-muted small">
                                                {row.child}
                                              </div>
                                            )}
                                            <div
                                              className={
                                                row.child ? "ms-3" : ""
                                              }
                                            >
                                              {row.ledger}
                                            </div>
                                          </td>

                                          {fetchedData?.data?.projects?.map(
                                            (proj, pi) => {
                                              let amount = 0
                                              const groupsArr =
                                                proj?.financial_summary?.costs
                                                  ?.direct?.other?.groups || []

                                              groupsArr.forEach(grp => {
                                                if (
                                                  grp.group_name === row.group
                                                ) {
                                                  grp.ledgers?.forEach(ld => {
                                                    if (
                                                      !row.child &&
                                                      ld.ledger_name ===
                                                        row.ledger
                                                    ) {
                                                      amount = ld.amount || 0
                                                    }
                                                  })

                                                  grp.children?.forEach(
                                                    child => {
                                                      if (
                                                        child.group_name ===
                                                        row.child
                                                      ) {
                                                        child.ledgers?.forEach(
                                                          ld => {
                                                            if (
                                                              ld.ledger_name ===
                                                              row.ledger
                                                            ) {
                                                              amount =
                                                                ld.amount || 0
                                                            }
                                                          }
                                                        )
                                                      }
                                                    }
                                                  )
                                                }
                                              })

                                              return (
                                                <td
                                                  key={pi}
                                                  className="text-end"
                                                >
                                                  {NumberFormat(
                                                    amount,
                                                    desimalrange,
                                                    desimalrange
                                                  )}
                                                </td>
                                              )
                                            }
                                          )}

                                          <td className="text-end fw-bold">
                                            {NumberFormat(
                                              fetchedData.data.projects.reduce(
                                                (sum, proj) => {
                                                  let amt = 0
                                                  const groupsArr =
                                                    proj?.financial_summary
                                                      ?.costs?.direct?.other
                                                      ?.groups || []

                                                  groupsArr.forEach(grp => {
                                                    if (
                                                      grp.group_name ===
                                                      row.group
                                                    ) {
                                                      grp.ledgers?.forEach(
                                                        ld => {
                                                          if (
                                                            !row.child &&
                                                            ld.ledger_name ===
                                                              row.ledger
                                                          ) {
                                                            amt = ld.amount || 0
                                                          }
                                                        }
                                                      )

                                                      grp.children?.forEach(
                                                        child => {
                                                          if (
                                                            child.group_name ===
                                                            row.child
                                                          ) {
                                                            child.ledgers?.forEach(
                                                              ld => {
                                                                if (
                                                                  ld.ledger_name ===
                                                                  row.ledger
                                                                ) {
                                                                  amt =
                                                                    ld.amount ||
                                                                    0
                                                                }
                                                              }
                                                            )
                                                          }
                                                        }
                                                      )
                                                    }
                                                  })

                                                  return sum + amt
                                                },
                                                0
                                              ),
                                              desimalrange,
                                              desimalrange
                                            )}
                                          </td>
                                        </tr>
                                      ))}
                                      {/* </tbody>
                                        </table>
                                      </td> */}
                                    </>
                                  )}
                                </React.Fragment>
                              )
                            })
                          })()}

                          {/* {fetchedData?.data?.projects?.length > 0 &&
                            [...Array(maxOtherCount)].map((_, rowIndex) => (
                              <tr key={rowIndex}>
                                {fetchedData.data.projects.map(
                                  (proj, colIndex) => {
                                    const invoice =
                                      proj?.financial_summary?.costs?.direct
                                        ?.others?.items?.[rowIndex]?.amount || 0
                                    const invoiceName =
                                      proj?.financial_summary?.costs?.direct
                                        ?.others?.items?.[rowIndex]?.type || "-"
                                    return (
                                      <>
                                        <td className="wdt-40px">
                                          {invoiceName}
                                        </td>
                                        <td
                                          key={colIndex}
                                          className="wdt-40px me-2 text-end"
                                        >
                                          <div className="me-2">
                                            {NumberFormat(
                                              Number(invoice),
                                              desimalrange,
                                              desimalrange
                                            )}
                                          </div>
                                        </td>
                                      </>
                                    )
                                  }
                                )}

                                <td className="wdt-40px text-end">
                                  <div className="me-2">
                                    {NumberFormat(
                                      fetchedData.data.projects.reduce(
                                        (sum, proj) => {
                                          const inv =
                                            proj?.financial_summary?.sales
                                              ?.invoices?.[rowIndex]?.number ||
                                            0
                                          return sum + Number(inv)
                                        },
                                        0
                                      ),
                                      desimalrange,
                                      desimalrange
                                    )}
                                  </div>
                                </td>
                              </tr>
                            ))} */}
                          {/* <tr>
                            <th className="wdt-40px">
                              Sub total - Direct Cost
                            </th>
                            {fetchedData?.data?.projects?.map((dt, i) => (
                              <th
                                key={i}
                                className="wdt-40px me-2 text-end"
                                title={
                                  dt?.financial_summary?.costs?.direct?.other
                                    ?.total || 0
                                }
                              >
                                {NumberFormat(
                                  Number(
                                    dt?.financial_summary?.costs?.direct?.other
                                      ?.total || 0
                                  ),
                                  desimalrange,
                                  desimalrange
                                )}
                              </th>
                            ))}
                            <th className="wdt-40px text-end">
                              {NumberFormat(
                                getProjectSums(
                                  fetchedData?.data?.projects,
                                  "financial_summary.costs.direct.other.total"
                                ),
                                desimalrange,
                                desimalrange
                              )}
                            </th>
                          </tr> */}
                          <tr>
                            <th></th>
                            {fetchedData?.data?.projects?.map((dt, i) => (
                              <th key={i} className="wdt-40px me-2"></th>
                            ))}
                            <th></th>
                          </tr>
                          <tr>
                            <th className="wdt-40px">Total Direct Cost</th>

                            {/* Per project totals */}
                            {fetchedData?.data?.projects?.map((dt, i) => {
                              const directCost =
                                (dt?.financial_summary?.costs?.direct?.materials
                                  ?.total || 0) +
                                (dt?.financial_summary?.costs?.direct?.labor
                                  ?.total || 0) +
                                (dt?.financial_summary?.costs?.direct
                                  ?.subcontractors?.total || 0) +
                                (dt?.financial_summary?.costs?.direct?.other
                                  ?.total || 0)

                              return (
                                <th
                                  key={i}
                                  className="wdt-40px me-2 text-end"
                                  title={directCost}
                                >
                                  <div className="me-2">
                                    {NumberFormat(
                                      Number(directCost),
                                      desimalrange,
                                      desimalrange
                                    )}
                                  </div>
                                </th>
                              )
                            })}

                            {/* Grand total */}
                            <th className="wdt-40px text-end">
                              <div className="me-2">
                                {NumberFormat(
                                  fetchedData?.data?.projects?.reduce(
                                    (sum, dt) => {
                                      const directCost =
                                        (dt?.financial_summary?.costs?.direct
                                          ?.materials?.total || 0) +
                                        (dt?.financial_summary?.costs?.direct
                                          ?.labor?.total || 0) +
                                        (dt?.financial_summary?.costs?.direct
                                          ?.subcontractors?.total || 0) +
                                        (dt?.financial_summary?.costs?.direct
                                          ?.other?.total || 0)

                                      return sum + directCost
                                    },
                                    0
                                  ),
                                  desimalrange,
                                  desimalrange
                                )}
                              </div>
                            </th>
                          </tr>
                          <tr>
                            <th className="wdt-40px">Gross Profit</th>

                            {/* Per project totals */}
                            {fetchedData?.data?.projects?.map((dt, i) => {
                              const directCost =
                                (dt?.financial_summary?.sales?.total_revenue ||
                                  0) -
                                (dt?.financial_summary?.costs?.direct?.materials
                                  ?.total || 0) +
                                (dt?.financial_summary?.costs?.direct?.labor
                                  ?.total || 0) +
                                (dt?.financial_summary?.costs?.direct
                                  ?.subcontractors?.total || 0) +
                                (dt?.financial_summary?.costs?.direct?.other
                                  ?.total || 0)

                              return (
                                <th
                                  key={i}
                                  className={`wdt-40px me-2 text-end ${
                                    Number(
                                      dt?.financial_summary?.gross_profit || 0
                                    ) < 0
                                      ? "text-danger"
                                      : ""
                                  }`}
                                  title={NumberFormat(
                                    Number(
                                      dt?.financial_summary?.gross_profit || 0
                                    ),
                                    desimalrange,
                                    desimalrange
                                  )}
                                >
                                  <div className="me-2">
                                    {NumberFormat(
                                      Number(
                                        dt?.financial_summary?.gross_profit || 0
                                      ),
                                      desimalrange,
                                      desimalrange
                                    )}
                                  </div>
                                </th>
                              )
                            })}

                            <th className="wdt-40px text-end">
                              <div
                                className={`me-2 ${
                                  getProjectSums(
                                    fetchedData?.data?.projects,
                                    "financial_summary.gross_profit"
                                  ) < 0
                                    ? "text-danger"
                                    : ""
                                }`}
                                title={NumberFormat(
                                  getProjectSums(
                                    fetchedData?.data?.projects,
                                    "financial_summary.gross_profit"
                                  ),
                                  desimalrange,
                                  desimalrange
                                )}
                              >
                                {NumberFormat(
                                  getProjectSums(
                                    fetchedData?.data?.projects,
                                    "financial_summary.gross_profit"
                                  ),
                                  desimalrange,
                                  desimalrange
                                )}
                              </div>
                            </th>
                          </tr>
                          <tr>
                            <th> </th>
                          </tr>
                          <tr>
                            <th className="wdt-40px">Indirect Expenses </th>
                          </tr>
                          {(() => {
                            const projectCount =
                              fetchedData?.data?.projects?.length || 0
                            const totalCols = projectCount + 2
                            const groups = [
                              ...new Set(uniqueIDRows.map(r => r.group)),
                            ]

                            return groups.map((groupName, gi) => {
                              const rowsForGroup = uniqueIDRows.filter(
                                r => r.group === groupName
                              )
                              const isExpanded =
                                expandedIDGroups[groupName] || false

                              return (
                                <React.Fragment key={`group-${gi}`}>
                                  {/* Toggle Row */}
                                  <tr
                                    className="cursor-pointer"
                                    onClick={() =>
                                      toggleGroupIDExpand(groupName)
                                    }
                                    style={{ backgroundColor: "#f8f9fa" }}
                                  >
                                    <td colSpan={totalCols} className="p-2">
                                      <div className="d-flex align-items-center">
                                        <span
                                          className="me-2"
                                          style={{
                                            transform: isExpanded
                                              ? "rotate(90deg)"
                                              : "rotate(0deg)",
                                            transition: "transform 0.3s ease",
                                            display: "inline-block",
                                          }}
                                        >
                                          ▶
                                        </span>
                                        <strong>{groupName}</strong>
                                      </div>
                                    </td>
                                  </tr>

                                  {/* Expanded Details Row */}
                                  {isExpanded && (
                                    <>
                                      {/* <td
                                        colSpan={totalCols}
                                        className="p-0 border-0"
                                      >
                                        <table className="table table-bordered table-sm mb-0">
                                          <thead>
                                            <tr
                                              style={{
                                                backgroundColor: "#f0f0f0",
                                              }}
                                            >
                                              <th>Ledger</th>
                                              {fetchedData?.data?.projects?.map(
                                                (p, i) => (
                                                  <th
                                                    key={i}
                                                    className="text-end"
                                                  >
                                                    {p.cost_center.name}
                                                  </th>
                                                )
                                              )}
                                              <th className="text-end">
                                                Total
                                              </th>
                                            </tr>
                                          </thead>

                                          <tbody> */}
                                      {rowsForGroup.map((row, ri) => (
                                        <tr key={ri}>
                                          <td className="wdt-40px">
                                            {row.child && (
                                              <div className="text-muted small">
                                                {row.child}
                                              </div>
                                            )}
                                            <div
                                              className={
                                                row.child ? "ms-3" : ""
                                              }
                                            >
                                              {row.ledger}
                                            </div>
                                          </td>

                                          {fetchedData?.data?.projects?.map(
                                            (proj, pi) => {
                                              let amount = 0
                                              const groupsArr =
                                                proj?.financial_summary?.costs
                                                  ?.indirect?.groups || []

                                              groupsArr.forEach(grp => {
                                                if (
                                                  grp.group_name === row.group
                                                ) {
                                                  grp.ledgers?.forEach(ld => {
                                                    if (
                                                      !row.child &&
                                                      ld.ledger_name ===
                                                        row.ledger
                                                    ) {
                                                      amount = ld.amount || 0
                                                    }
                                                  })

                                                  grp.children?.forEach(
                                                    child => {
                                                      if (
                                                        child.group_name ===
                                                        row.child
                                                      ) {
                                                        child.ledgers?.forEach(
                                                          ld => {
                                                            if (
                                                              ld.ledger_name ===
                                                              row.ledger
                                                            ) {
                                                              amount =
                                                                ld.amount || 0
                                                            }
                                                          }
                                                        )
                                                      }
                                                    }
                                                  )
                                                }
                                              })

                                              return (
                                                <td
                                                  key={pi}
                                                  className="text-end"
                                                >
                                                  {NumberFormat(
                                                    amount,
                                                    desimalrange,
                                                    desimalrange
                                                  )}
                                                </td>
                                              )
                                            }
                                          )}

                                          <td className="text-end fw-bold">
                                            {NumberFormat(
                                              fetchedData.data.projects.reduce(
                                                (sum, proj) => {
                                                  let amt = 0
                                                  const groupsArr =
                                                    proj?.financial_summary
                                                      ?.costs?.indirect
                                                      ?.groups || []

                                                  groupsArr.forEach(grp => {
                                                    if (
                                                      grp.group_name ===
                                                      row.group
                                                    ) {
                                                      grp.ledgers?.forEach(
                                                        ld => {
                                                          if (
                                                            !row.child &&
                                                            ld.ledger_name ===
                                                              row.ledger
                                                          ) {
                                                            amt = ld.amount || 0
                                                          }
                                                        }
                                                      )

                                                      grp.children?.forEach(
                                                        child => {
                                                          if (
                                                            child.group_name ===
                                                            row.child
                                                          ) {
                                                            child.ledgers?.forEach(
                                                              ld => {
                                                                if (
                                                                  ld.ledger_name ===
                                                                  row.ledger
                                                                ) {
                                                                  amt =
                                                                    ld.amount ||
                                                                    0
                                                                }
                                                              }
                                                            )
                                                          }
                                                        }
                                                      )
                                                    }
                                                  })

                                                  return sum + amt
                                                },
                                                0
                                              ),
                                              desimalrange,
                                              desimalrange
                                            )}
                                          </td>
                                        </tr>
                                      ))}
                                      {/* </tbody>
                                        </table>
                                      </td> */}
                                    </>
                                  )}
                                </React.Fragment>
                              )
                            })
                          })()}
                          {fetchedData?.data?.projects?.length > 0 &&
                            [...Array(maxOtherCount)].map((_, rowIndex) => (
                              <tr key={rowIndex}>
                                {fetchedData.data.projects.map(
                                  (proj, colIndex) => {
                                    const invoice =
                                      proj?.financial_summary?.costs?.indirect
                                        ?.expenses?.[rowIndex]?.amount || 0
                                    const invoiceName =
                                      proj?.financial_summary?.costs?.indirect
                                        ?.expenses?.[rowIndex]?.type || "-"
                                    return (
                                      <>
                                        <td className="wdt-40px">
                                          {invoiceName}
                                        </td>
                                        <td
                                          key={colIndex}
                                          className="wdt-40px me-2 text-end"
                                        >
                                          <div className="me-2">
                                            {NumberFormat(
                                              Number(invoice),
                                              desimalrange,
                                              desimalrange
                                            )}
                                          </div>
                                        </td>
                                      </>
                                    )
                                  }
                                )}

                                {/* Total for this invoice row */}
                                <td className="wdt-40px text-end">
                                  <div className="me-2">
                                    {NumberFormat(
                                      fetchedData.data.projects.reduce(
                                        (sum, proj) => {
                                          const inv =
                                            proj?.financial_summary?.costs
                                              ?.indirect?.[rowIndex]?.amount ||
                                            0
                                          return sum + Number(inv)
                                        },
                                        0
                                      ),
                                      desimalrange,
                                      desimalrange
                                    )}
                                  </div>
                                </td>
                              </tr>
                            ))}
                          <tr>
                            <th className="wdt-40px">Total In-Direct Cost</th>
                            {fetchedData?.data?.projects?.map((dt, i) => (
                              <th
                                key={i}
                                className="wdt-40px me-2 text-end"
                                title={
                                  dt?.financial_summary?.costs?.indirect
                                    ?.total || 0
                                }
                              >
                                <div className="me-2">
                                  {NumberFormat(
                                    Number(
                                      dt?.financial_summary?.costs?.indirect
                                        ?.total || 0
                                    ),
                                    desimalrange,
                                    desimalrange
                                  )}
                                </div>
                              </th>
                            ))}
                            <th className="wdt-40px text-end">
                              <div className="me-2">
                                {NumberFormat(
                                  getProjectSums(
                                    fetchedData?.data?.projects,
                                    "financial_summary.costs.indirect.total"
                                  ),
                                  desimalrange,
                                  desimalrange
                                )}
                              </div>
                            </th>
                          </tr>
                          <tr>
                            <th></th>
                            {fetchedData?.data?.projects?.map((dt, i) => (
                              <th key={i} className="wdt-40px me-2"></th>
                            ))}
                            <th></th>
                          </tr>
                          <tr>
                            <th className="wdt-40px">Net Profit</th>

                            {/* Per project totals */}
                            {fetchedData?.data?.projects?.map((dt, i) => {
                              const directCost =
                                (dt?.financial_summary?.costs?.indirect
                                  ?.total || 0) -
                                ((dt?.financial_summary?.sales?.total_revenue ||
                                  0) -
                                  (dt?.financial_summary?.costs?.direct
                                    ?.materials?.total || 0) +
                                  (dt?.financial_summary?.costs?.direct?.labor
                                    ?.total || 0) +
                                  (dt?.financial_summary?.costs?.direct
                                    ?.subcontractors?.total || 0) +
                                  (dt?.financial_summary?.costs?.direct?.other
                                    ?.total || 0))

                              return (
                                <th
                                  key={i}
                                  className={`wdt-40px me-2 text-end ${
                                    Number(
                                      dt?.financial_summary?.net_profit || 0
                                    ) < 0
                                      ? "text-danger"
                                      : ""
                                  }`}
                                  title={NumberFormat(
                                    Number(
                                      dt?.financial_summary?.net_profit || 0
                                    ),
                                    desimalrange,
                                    desimalrange
                                  )}
                                >
                                  <div className="me-2">
                                    {NumberFormat(
                                      Number(
                                        dt?.financial_summary?.net_profit || 0
                                      ),
                                      desimalrange,
                                      desimalrange
                                    )}
                                  </div>
                                </th>
                              )
                            })}

                            {/* Grand total */}
                            <th className="wdt-40px text-end">
                              <div
                                className={`me-2 ${
                                  getProjectSums(
                                    fetchedData?.data?.projects,
                                    "financial_summary.net_profit"
                                  ) < 0
                                    ? "text-danger"
                                    : ""
                                }`}
                                title={NumberFormat(
                                  getProjectSums(
                                    fetchedData?.data?.projects,
                                    "financial_summary.net_profit"
                                  ),
                                  desimalrange,
                                  desimalrange
                                )}
                              >
                                {NumberFormat(
                                  getProjectSums(
                                    fetchedData?.data?.projects,
                                    "financial_summary.net_profit"
                                  ),
                                  desimalrange,
                                  desimalrange
                                )}
                                {/* {NumberFormat(
                                  fetchedData?.data?.projects?.reduce(
                                    (sum, dt) => {
                                      const directCost =
                                        (dt?.financial_summary?.costs?.indirect
                                          ?.total || 0) -
                                        ((dt?.financial_summary?.sales
                                          ?.total_revenue || 0) -
                                          (dt?.financial_summary?.costs?.direct
                                            ?.materials?.total || 0) +
                                          (dt?.financial_summary?.costs?.direct
                                            ?.labor?.total || 0) +
                                          (dt?.financial_summary?.costs?.direct
                                            ?.subcontractors?.total || 0) +
                                          (dt?.financial_summary?.costs?.direct
                                            ?.other?.total || 0))

                                      return sum + directCost
                                    },
                                    0
                                  ),
                                  desimalrange,
                                  desimalrange
                                )} */}
                              </div>
                            </th>
                          </tr>
                          <tr>
                            <th> </th>
                          </tr>
                          <tr>
                            <th className="wdt-40px">GP%</th>

                            {/* Per project GP% */}
                            {fetchedData?.data?.projects?.map((dt, i) => {
                              const revenue =
                                dt?.financial_summary?.sales?.total_revenue || 0

                              const materials =
                                dt?.financial_summary?.costs?.direct?.materials
                                  ?.total || 0
                              const labor =
                                dt?.financial_summary?.costs?.direct?.labor
                                  ?.total || 0
                              const subcontractors =
                                dt?.financial_summary?.costs?.direct
                                  ?.subcontractors?.total || 0
                              const other =
                                dt?.financial_summary?.costs?.direct?.other
                                  ?.total || 0

                              const indirect =
                                dt?.financial_summary?.costs?.indirect?.total ||
                                0

                              // Direct Cost
                              const directCost =
                                indirect -
                                (revenue -
                                  (materials + labor + subcontractors + other))

                              // Gross Profit
                              const gp = revenue - directCost

                              // GP%
                              const gpPercent =
                                revenue > 0 ? (gp / revenue) * 100 : 0

                              return (
                                <th
                                  key={i}
                                  className="wdt-40px me-2 text-end"
                                  title={NumberFormat(
                                    Math.round(dt?.financial_summary?.gp || 0), // round to no decimals
                                    0,
                                    0
                                  )}
                                >
                                  <div
                                    className={`me-2 ${
                                      Math.round(
                                        dt?.financial_summary?.gp || 0
                                      ) < 0
                                        ? "text-danger"
                                        : ""
                                    }`}
                                  >
                                    {NumberFormat(
                                      Math.round(
                                        dt?.financial_summary?.gp || 0
                                      ), // round to no decimals
                                      0,
                                      0
                                    )}
                                    %
                                  </div>
                                </th>
                              )
                            })}

                            {/* Grand Total GP% */}
                            <th className="wdt-40px text-end">
                              <div
                                className={`me-2 ${
                                  Number(
                                    getProjectSums(
                                      fetchedData?.data?.projects,
                                      "financial_summary.gp"
                                    ) / fetchedData?.data?.projects?.length
                                  ) < 0
                                    ? "text-danger"
                                    : ""
                                }`}
                              >
                                {NumberFormat(
                                  Number(
                                    getProjectSums(
                                      fetchedData?.data?.projects,
                                      "financial_summary.gp"
                                    ) / fetchedData?.data?.projects?.length
                                  ),
                                  0,
                                  0
                                )}
                                %
                              </div>
                            </th>
                          </tr>
                        </tbody>
                      </table>

                      {page < fetchedData?.meta?.last_page && (
                        <div
                          className="cost-center-bar d-flex justify-content-center mb-2"
                          // ref={loadMoreRef}
                        >
                          <LoadingButton
                            color="primary"
                            onClick={() => setPage(prev => prev + 1)}
                            loading={isLoading}
                          >
                            Load More
                          </LoadingButton>
                        </div>
                      )}
                    </div>
                  ) : (
                    <div className="d-flex mt-5 justify-content-center align-items-center fw-bold text-mute">
                      No Data Found
                    </div>
                  )}
                </Col>
              </Row>
            </div>
          </Card>
        </div>
      </div>
    </React.Fragment>
  )
}

export default ProjectCostingReport
